import Image from "next/image";
const Tools = (props) => {
  return (
    <div className="grid mx-7 lg:mx-10 2xl:mx-28 bg-white">
      <div className="grid grid-cols-2 sm:grid-cols-3">
        <div className="flex border border-gray-200 items-center py-10 sm:py-16 px-3 sm:px-0">
          <img
            className="flex text-center mx-auto"
            alt="vlsi tools image"
            src="/images/VLSI/cad.png"
          />
        </div>
        <div className="border border-gray-200 items-center py-10 sm:py-16 px-3 sm:px-0">
          <img
            className="flex text-center mx-auto"
            alt="vlsi tools image"
            src="/images/VLSI/mentor.png"
          />
        </div>
        <div className="border border-gray-200 items-center py-10 sm:py-16 px-3 sm:px-0">
          <img
            className="flex text-center mx-auto lg:w-1/2"
            alt="vlsi tools image"
            src="/images/VLSI/landing/synopsis.png"
          />
        </div>
        <div className="border border-gray-200 items-center py-10 sm:py-16 px-3 sm:px-0">
          <img
            className="flex text-center mx-auto"
            alt="vlsi tools image"
            src="/images/VLSI/vivado.png"
          />
        </div>
        <div className="border border-gray-200 items-center py-10 sm:py-16 px-3 sm:px-0">
          <img
            className="flex text-center mx-auto"
            alt="vlsi tools image"
            src="/images/VLSI/cotbo.png"
          />
        </div>
        <div className="border border-gray-200 items-center py-10 sm:py-16 px-3 sm:px-0">
          <img
            className="flex text-center mx-auto"
            alt="vlsi tools image"
            src="/images/VLSI/veri.png"
          />
        </div>
        <div className="border border-gray-200 items-center py-10 sm:py-16 px-3 sm:px-0">
          <img
            className="flex text-center mx-auto lg:w-1/2"
            alt="vlsi tools image"
            src="/images/VLSI/landing/jenkins.png"
          />
        </div>
        <div className="border border-gray-200 items-center py-10 sm:py-16 px-3 sm:px-0">
          <img
            className="flex text-center mx-auto lg:w-1/2"
            alt="vlsi tools image"
            src="/images/VLSI/landing/gitlab.png"
          />
        </div>
        <div className="border border-gray-200 items-center py-10 sm:py-16 px-3 sm:px-0">
          <img
            className="flex text-center mx-auto lg:w-1/2"
            alt="vlsi tools image"
            src="/images/VLSI/landing/github.png"
          />
        </div>
        <div className="border border-gray-200 items-center py-10 sm:py-16 px-3 sm:px-0">
          <img
            className="flex text-center mx-auto"
            alt="vlsi tools image"
            src="/images/VLSI/rtos.png"
          />
        </div>
      </div>
    </div>
  );
};

export default Tools;
